import React , { Component } from 'react';
import PaginationList from "../../common/Paginator/PaginationList";
import ellipsisContent from "../../utils/EllipsisContent";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import style from './LatestNews.module.css';
import newsDetailPushTarget from "../../utils/NewsDetailPushTarget";


class LatestNews extends Component {

    render(){
        return(
            <PaginationList
                style={{background: '#f0f2f5',maxWidth:'272px'}}
                title="最新资讯"
                titleStyle={{justifyContent: 'center', padding: 0}}
                hidePagination
                url="/api/news"
                requestOption={{headers: {Accept: 'application/json,version=3'}}}
                renderItem={item => {
                    const { id, cover_link, title = '', tab } = item;
                    return(
                        <div key={id} className={style.wrapper}  style={{backgroundImage:`url(${cover_link})`}} onClick={() => {
                            this.props.history.push({ pathname: `/${newsDetailPushTarget(tab)}/${id}`});
                        }}>
                            <div className={style.title}>{ellipsisContent(title, 15)}</div>
                        </div>
                    );
                }}
                onGetDataFinish={(data) => {
                    data.list = data.list.slice(0, 3);
                    return data;
                }}
            />
        );

    }
}

export default connect()(withRouter(LatestNews));
